import React, { useState } from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { useNovaToast } from 'hooks/utils/useNovaToast';
import { ToastVariant } from 'types/Toast';

type CopyToClipboardProps = {
  text: string;
  successMessage?: string;
  errorMessage?: string;
};

export const CopyToClipboard = ({
  text,
  successMessage = 'Link kopiert!',
  errorMessage = 'Fehler beim Kopieren',
}: CopyToClipboardProps): React.ReactElement => {
  const [hasCopied, setHasCopied] = useState(false);
  const { show: showToast } = useNovaToast();

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      setHasCopied(true);
      showToast({
        title: successMessage,
        variant: ToastVariant.SUCCESS,
      });

      // Reset copy state after 2 seconds
      setTimeout(() => setHasCopied(false), 2000);
    } catch (error) {
      showToast({
        title: errorMessage,
        variant: ToastVariant.ERROR,
      });
    }
  };

  return (
    <Flex flexDirection="row" gap="l" alignItems="center" maxW="100%">
      <Flex
        alignItems="center"
        gap="0"
        bg="background.secondary"
        borderRadius="lg"
        border="default"
        borderColor="border.accent"
        overflow="hidden"
        maxW="100%"
        minH="44px"
        paddingLeft="10px"
      >
        <Text
          color="text.primary"
          textStyle="body.m.regular"
          lineClamp={1}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          flex="1"
          minW="0"
          px="10px"
          py="10px"
          fontFamily="mono"
        >
          {text}
        </Text>
      </Flex>
      <Button onClick={handleCopy} variant="primary" flexShrink={0}>
        {hasCopied ? 'Kopiert' : 'Kopieren'}
      </Button>
    </Flex>
  );
};
